import { render, staticRenderFns } from "./AppSettings.vue?vue&type=template&id=6d01fe2c&"
import script from "./AppSettings.vue?vue&type=script&lang=js&"
export * from "./AppSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports